import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { breakpoints } from '../../constants';

const Contact = styled.div`
    margin-bottom: 20px;
    h5 {
        color: #25bcef;
        margin-bottom: 0;
    }
    p {
        color: white;
    }
`;

const Contacts = styled.div`
    ul {
        display: flex;
        flex-wrap: wrap;
        li {
            margin-bottom: 20px;
            width: 45%;
            padding: 0 1rem;
            @media (max-width: ${breakpoints.mobile}) {
                // padding-left: 0;
            }
            @media (max-width: ${breakpoints.mobile}) {
                width: 100%;
            }
        }
    }
    h5 {
        color: #25bcef;
        margin-bottom: 0;
    }
    p {
        color: white;
    }
`;

const StyledFooter = styled.footer`
    height: 420px;
    background-color: #003056;
    @media (max-width: ${breakpoints.tablet}) {
        height: auto;
    }
    @media (max-width: ${breakpoints.mobile}) {
        padding: 20px 10px;
    }
`;

const Title = styled.div`
    padding-left: 200px;
    @media (max-width: ${breakpoints.tablet}) {
        padding: 30px;
    }
`;

const Copyright = styled.div`
    color: white;
    @media (max-width: ${breakpoints.tablet}) {
        padding: 30px;
    }
`;

const Footer = ({ data }) => (
    <StyledFooter className="footer">
        <div className="columns">
            <Title className="column is-4">
                <h4 className="title is-4" style={{ color: 'white' }}>
                    <FormattedMessage id="contacts.title" />
                </h4>
            </Title>
            <div className="column is-6">
                <Contacts
                    dangerouslySetInnerHTML={{
                        __html: data.content.childMarkdownRemark.html,
                    }}
                />
            </div>
            <Copyright className="column is-2">
                <p style={{ marginBottom: '15px' }}>
                    &copy; {new Date().getFullYear()} RUBAE
                </p>
                <p>
                    <a
                        href="https://facebook.com/RUBAEshow/"
                        target="_blank"
                        className="icon is-medium"
                        style={{ color: 'white' }}
                    >
                        <i className="fab fa-lg fa-facebook" />
                    </a>
                    <a
                        href="https://instagram.com/rubaeshow"
                        target="_blank"
                        className="icon is-medium"
                        style={{ color: 'white' }}
                    >
                        <i className="fab fa-lg fa-instagram" />
                    </a>
                </p>
                {/* <p><a style={{color: 'white'}}>{messages.contacts.legalInfo}</a></p> */}
                {/* <p><a style={{color: 'white'}}>{messages.contacts.confidention}</a></p> */}
            </Copyright>
        </div>
    </StyledFooter>
);

export default Footer;

export const footerContacts = graphql`
    fragment FooterContacts on ContentfulBlock {
        node_locale
        content {
            childMarkdownRemark {
                html
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/layouts/components/Footer.js